module.exports = __webpack_public_path__ + "media/images/pic/testimonials/naza-4e93791875700a9ce72abc34565dc0a5.webp";